import { DetailData } from "@/types/Syain";
import { reactive, ref } from "vue";

export interface KoyouKeiyakuNotesData {
    notes: string,
}

export function useNotesSyuuseiModal() {
  const notesSyuuseiModalRef = ref()
  const syuuseiData: KoyouKeiyakuNotesData = reactive({
    notes: ''
  })

  const setData = async (syuuseiTarget: DetailData | null) => {
    if (!syuuseiTarget) {
      return
    }
    syuuseiData.notes = syuuseiTarget.koyou_keiyaku_notes ?? ''
  }

  const clearData = async () => {
    syuuseiData.notes = ''
  }

  const notesSyuuseiModalParts = reactive({
    title: '備考（雇用契約）の変更',
    button: ''
  })

  const openNotesSyuuseiModal = () => {
    notesSyuuseiModalRef.value.open()
  }

  const closeNotesSyuuseiModal = () => {
    notesSyuuseiModalRef.value.close()
  }

  return {
    notesSyuuseiModalRef,
    notesSyuuseiModalParts,
    openNotesSyuuseiModal,
    closeNotesSyuuseiModal,
    syuuseiData,
    setData,
    clearData
  }
}
